export default {
  title: 'Workspace',
  tab: {
    account: 'Account',
    settings: 'Settings',
    members: 'Members',
    theme: 'Theme',
    pricing: 'Pricing',
    billing: 'Billing',
    notifications: 'Notifications',
    integrations: 'Integrations'
  },
  workspace: {
    heading: 'Workspace Settings',
    display_name: 'Workspace Name',
    description: 'This is the name for your workspace',
    placeholder: 'Yoda',
    error: 'Please enter a product space name',
    min_length_error: 'Workspace name should have a minimum of 4 characters',
    api_key_label: 'API key',
    api_key_description:
      'Use the above key to access our APIs. Make sure that this key is stored at your server side in a secure manner.',
    api_key_regenerate_description:
      'After regeneration, old key will be accessible for 24 hours. Please contact us if you wish to disable the key immediately.'
  },
  account: {
    heading: 'Account Settings',
    name: {
      label: 'Your name'
    },
    change_password: 'Change password',
    password: {
      old_label: 'Old password',
      new_label: 'New password',
      success: 'Your password has been changed successfully.'
    }
  },
  theme: {
    logo: {
      label: 'Your Logo',
      description:
        'The logo you uploaded will be used in displaying intro and outro slides of the video'
    },
    color: {
      label: 'Theme',
      description: 'The player will be customised to the brand color selected'
    }
  },
  billing: {
    manage_payments: {
      label: 'Manage your payment details',
      description:
        'You can view and modify the payment method that is used for payments.',
      cta: 'Manage'
    },
    invoices: {
      label: 'Invoices',
      description: 'View and download your payment history.',
      cta: 'View Invoices'
    },
    cancel_subscription: {
      label: 'Cancel subscription',
      description:
        'You can cancel your subscription. You will not be charged further after cancelling the subscription. You can access the workspace till the end of trial or till the end of the current billing month',
      reactivate_description: 'Subscription cancellation: %{date}',
      cta: 'Cancel subscription',
      reactivate_cta: 'Reactivate cancelled subscription'
    }
  },
  notifications: {
    email_digest: {
      title: 'Email Digest',
      description:
        'Choose the frequencies, on when you wish to recieve video engagement digest emails.',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly'
    }
  },
  current_plan: 'You are currently on %{plan_name} plan.',
  next_billing_on: 'Your next billing is on %{next_billing_date}.',
  members: {
    label: 'Email',
    placeholder: 'John@yoda.io',
    user: 'User',
    role: 'Role',
    send_digest_emails: 'Send Digest Emails'
  },
  invites: {
    title: 'Pending Invites',
    re_invite: 'Re-invite',
    revoke: 'Revoke'
  },
  pricing: {
    old_pricing: `You are currently in our old pricing structure. Kindly <a href="mailto:support@trainn.co"> contact us </a> to unlock the advantages of our new pricing.`,
    view_features: 'View Features',
    next_billing: 'Your Next Billing is on',
    free: {
      title: 'Free Plan',
      caption: 'Basic plan with 3 videos and 1 additional colloborator'
    },
    standard: {
      title: 'Standard Plan',
      caption: 'Everything you need to train your customers',
      1: 'Unlimited Videos',
      2: 'Unlimited Learning Paths',
      3: 'Unlimited Colloborators',
      4: 'Video Hub',
      5: 'Detailed Analytics',
      6: '%{allowed_minutes} engagement minutes every month',
      note: `Additional $1 for %{overage_minutes} engagement minutes`
    },
    addon: {
      tag: 'Addon',
      brand: {
        title: 'Brand Personalisation',
        features: {
          1: 'Custom Domain',
          2: 'Remove Trainn Branding',
          3: 'Logo Watermarking'
        }
      }
    },
    custom: {
      standard_title: 'Standard Plan',
      standard_caption: 'Everything you need to train your customers',
      enterprise_title: 'Enterprise Plan',
      enterprise_caption:
        'For organizations that need additional control and end to end support',
      tagline: 'Only pay for what you need. Our pricing is based on,',
      pricing: {
        1: 'Number of Monthly Active Users',
        2: 'Number of Collaborators',
        3: 'Number of Videos'
      },
      features: {
        1: 'Academy with Learning Flow',
        2: 'Detailed Analytics',
        3: 'Custom Domain',
        4: 'Brand Personalization',
        5: 'Custom Roles & Permissions',
        6: 'Dedicated Account Manager',
        7: 'Custom contract',
        everything: 'Everything in Standard'
      }
    }
  },
  integrations: {
    connect: 'Connect',
    disconnect: 'Disconnect',
    youtube: {
      contact_support: `Kindly <a href="mailto:support@trainn.co"> contact us </a> to enable youtube integration for your workspace.`,
      title: 'YouTube Integration',
      desc: 'Publish your videos to your YouTube channel',
      channel_name: 'Channel Name'
    }
  },
  disabled_reason: `%{feature} doesnot match the allowed configuration`,
  access_limit: {
    collaborators: 'Your current plan does not allow you to add more creators.',
    collection: 'Your current plan does not allow you to add learning paths.',
    download_images: 'Your current plan does not allow you to download images.',
    download_pdf: 'Your current plan does not allow you to download pdf.',
    upload_videos: 'Your current plan does not allow you to upload videos.',
    insta_videos:
      'Your current plan does not allow you to use Trainn Instant feature.',
    watermark: 'Your current plan does not allow you to add watermark.',
    hub: 'Your current plan does not allow you to enable video hub.',
    flow: 'Unlock Flow!'
  }
};
